<template>
  <div class="loader-container" :class="{ full: fullPage }">
    <div class="loader-group">
      <div v-if='showAnimation'>
        <img src="@/assets/img/logo_nedgia-icon.png" class="loader-image" :class="loaderClass" style="max-width: 50px;">
        <div class="hexagon loader" :class="loaderClass">
          <div class="ball ball_one"></div>
          <div class="ball ball_two"></div>
          <div class="ball ball_three"></div>
        </div>
        <svg class="svg-filter">
          <defs>
            <filter id="filter">
              <feGaussianBlur in="SourceGraphic" stdDeviation="18" result="blur" />
              <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 28 -10" result="filter" />
              <feComposite in="SourceGraphic" in2="filter" operator="atop" />
            </filter>
          </defs>
        </svg>
      </div>
      <p class="text-center">
        {{msg}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    showAnimation: {
      type: Boolean,
      default: true
    },
    msg: {
      type: String,
      default: 'Loading...'
    },
    fullPage: {
      type: Boolean,
      default: false
    },
    delay: {
      type: Number,
      default: 800
    }
  },
  methods: {
    timeToShine: function () {
      var v = this;
      setTimeout(function () {
        v.loaderClass = 'd-visible';
      }, this.delay);
    }
  },
  mounted () {
    if (this.fullPage === false) {
      this.timeToShine();
    } else {
      this.loaderClass = 'd-visible';
    }
  },
  data () {
    return {
      loaderClass: 'd-invisible'
    };
  }
};
</script>

<style lang="scss" scoped="true">
  @import 'src/assets/styles/mixins.scss';
  @import 'src/assets/styles/libs.scss';

  $loaderColor: $accentColor;
  $ballColor: $brandingColor;
  $loaderSize: 90px;
  $loaderSpeed: 9s;

  .d-invisible {
    opacity: 0;
    overflow: hidden;
    position: absolute;
  }
  .d-visible {
    opacity: 1;
    overflow: initial;
    position: relative;
  }
  .loader-group {
    width: $loaderSize;
    margin: ($loaderSize / 3) auto;
    position: relative;
    .svg-filter {
      position: absolute
    }
  }
  .loader-image {
    margin: 0 auto;
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 10px;
    width: ($loaderSize / 1.7);
    z-index: 2;
  }
  .loader-container {
    &.full {
      $loaderSize: ($loaderSize * 2);
      background: rgba(#ffffff, 0.8);
      position: fixed;
      top: 0; right: 0; bottom: 0; left: 0;
      width: 100%; height: 100%;
      z-index: 9999;
      .loader-group {
        margin: auto auto;
        width: ($loaderSize);
        position: absolute;
        top: 40%; right: 0; bottom: 0; left: 0;
      }
      .loader-image {
        width: ($loaderSize / 2);
      }
      .hexagon {
        margin-bottom: ($loaderSize / 2);
        width: ($loaderSize); height: (($loaderSize) / 1.73197661832);
        &:before,
        &:after {
          border-left: (($loaderSize) / 2) solid transparent;
          border-right: (($loaderSize) / 2) solid transparent;
        }
        &:before {
          border-bottom: (($loaderSize) / 3.46395323663) solid $loaderColor;
        }
        &:after {
          border-top: (($loaderSize) / 3.46395323663) solid $loaderColor;
        }
      }
      .ball_one {
        width: ($loaderSize / 1.5); height: ($loaderSize / 1.5);
      }
      .ball_two {
        width: ($loaderSize / 2); height: ($loaderSize / 2);
      }
      .ball_three {
        width: ($loaderSize / 2.5); height: ($loaderSize / 2.5);
      }
    }
  }
  .hexagon {
    animation: spin $loaderSpeed linear infinite;
    margin-bottom: ($loaderSize / 2);
    transition: 2s linear all;
    width: $loaderSize; height: ($loaderSize / 1.73197661832);
    &:before,
    &:after {
      content: "";
      border-left: ($loaderSize / 2) solid transparent;
      border-right: ($loaderSize / 2) solid transparent;
      position: absolute;
      width: 0;
    }
    &:before {
      bottom: 100%;
      border-bottom: ($loaderSize / 3.46395323663) solid $loaderColor;
    }
    &:after {
      top: 100%;
      width: 0;
      border-top: ($loaderSize / 3.46395323663) solid $loaderColor;
    }
  }
  .bubble {
    @include border-radius(100%);
    width: $loaderSize; height: $loaderSize;
  }
  .loader {
    background: $loaderColor;
    filter: url("#filter");
    z-index: 1;
    .ball {
      position: absolute;
      top: calc(50% - 0);
      left: calc(50% - 0);
      z-index: 4;
      &:before {
        @include border-radius(100%);
        background: rgba($ballColor, .7);
        content: '';
        left: 0;
        position: absolute;
        top: 0;
        width: 100%; height: 100%;
      }
    }
    .ball_one {
      animation: x-axis-lateral ($loaderSpeed / 2) infinite alternate ease-in-out;
      width: ($loaderSize / 1.5); height: ($loaderSize / 1.5);
      &:before {
        animation: y-axis-lateral ($loaderSpeed / 3)  infinite ($loaderSpeed / 4.5)  alternate ease-in-out;
      }
    }
    .ball_two {
      animation: x-axis ($loaderSpeed / 2) infinite alternate ease-in-out;
      width: ($loaderSize / 2); height: ($loaderSize / 2);
      &:before {
        animation: y-axis 4s infinite 2s alternate ease-in-out;
      }
    }
    .ball_three {
      transform: translate(966px, 78px);
      animation: x-axis-lateral ($loaderSpeed / 2) infinite alternate ease;
      width: ($loaderSize / 2.5); height: ($loaderSize / 2.5);
      &:before {
        animation: y-axis-lateral ($loaderSpeed / 3) infinite ($loaderSpeed / 4.5)  alternate ease-in-out;
      }
    }
  }

  @keyframes x-axis {
    0% {
      transform: translate(-($loaderSize / 3.2));
    }
    100% {
      transform: translate(($loaderSize / 3.2));
    }
  }

  @keyframes y-axis {
    0% {
      transform: translateY(($loaderSize / 3.4));
    }
    100% {
      transform: translateY(-($loaderSize / 3.4)) scale(0.8);
    }
  }

  @keyframes x-axis-lateral {
    0% {
      transform: translate(-($loaderSize / 4.4));
    }
    100% {
      transform: translate(($loaderSize / 4.4));
    }
  }

  @keyframes y-axis-lateral {
    0% {
      transform: translate(($loaderSize / 4.4));
    }
    100% {
      transform: translate(-($loaderSize / 4.4));
    }
  }
  @keyframes spin {
    100% {
      transform:rotate(360deg);
    }
  }
   // Hide effects on safari for fixing bug
  @media not all and (min-resolution:.001dpcm) { @supports (-webkit-appearance:none) {
    .loader {
      filter: none;
    }
    .ball {
      display: none;
    }
  }}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Loader.vue